const config = {
  india: {
    UATUrl: "https://nura-desk-in-uat.onedesk.app/login",
    Username: "hyder@soxo.in",
    Password: "Hyder@123",
    UATBranches: "Calicut",
    nuraID: "N1KZ2920",
    Title: "Ms.",
    CreditBillUser: "Sareena",
    AdvancedSearchFirstName: "Sareena",
    AdvancedSearchlastName: "Khan",
    AdvancedSearchEmail: "test2@gmail.com",
    AdvancedSearchPhone: "9745334567",
    expectedData: {
      package: "Female Package",
      schedule: "07:40 am - 07:50 am",
      planned: "10:30 am - 12:30 pm",
      bills: [
        "Vitamin B12",
        "25-hydroxy Vitamin D",
        "Waiting for the Next Step",
        "Waiting for consultation",
      ],
    },
    user: {
      firstname: "Nithu",
      lastname: "Maya",
    },
  },
  mongolia: {
    UATUrl: "https://nura-desk-mn-uat.onedesk.app/login",
    Username: "techsupport@nura.in",
    Password: "TechSupport@123",
    UATBranches: "Ulaanbaatar",
    nuraID: "N2MN5678",
    Title: "Mr.",
    CreditBillUser: "Bataar",
    AdvancedSearchFirstName: "Bataar",
    AdvancedSearchlastName: "Khaan",
    AdvancedSearchEmail: "bataar@nura.mn",
    AdvancedSearchPhone: "9876543210",
    expectedData: {
      package: "Male Package",
      schedule: "08:00 am - 08:30 am",
      planned: "11:00 am - 01:00 pm",
      bills: ["Blood Test", "X-Ray"],
    },
    user: {
      firstname: "Bataar",
      lastname: "Khaan",
    },
  },
  vietnam: {
    UATUrl: "https://nura-desk-vn-uat.onedesk.app/login",
    Username: "admin@nura.vn",
    Password: "Admin@456",
    UATBranches: "Hanoi",
    nuraID: "N3VN9012",
    Title: "Ms.",
    CreditBillUser: "Linh",
    AdvancedSearchFirstName: "Linh",
    AdvancedSearchlastName: "Nguyen",
    AdvancedSearchEmail: "linh@nura.vn",
    AdvancedSearchPhone: "8765432109",
    expectedData: {
      package: "Family Package",
      schedule: "09:00 am - 09:30 am",
      planned: "02:00 pm - 04:00 pm",
      bills: ["ECG", "Ultrasound"],
    },
    user: {
      firstname: "Linh",
      lastname: "Nguyen",
    },
  },
};

export default config;